import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
export const Tag = forwardRef<HTMLDivElement, {
  icon?: string;
  content: string;
  variant?: 'primary' | 'secondary' | 'success' | 'error';
  disabled?: boolean;
  noWrap?: boolean;
}>((t0, ref) => {
  const $ = _c(32);
  let content;
  let icon;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      icon,
      content,
      variant: t1,
      disabled: t2,
      noWrap: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = icon;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    content = $[1];
    icon = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const variant = t1 === undefined ? "primary" : t1;
  const disabled = t2 === undefined ? false : t2;
  const noWrap = t3 === undefined ? false : t3;
  const statusColor = disabled || variant === "primary" || variant === "secondary" ? undefined : `var(--mui-palette-${variant}-main)`;
  const t4 = statusColor ?? (variant === "secondary" || disabled ? "var(--mui-palette-text-secondary)" : "var(--mui-palette-text-primary)");
  let t5;
  if ($[7] !== t4) {
    t5 = {
      color: t4,
      fontWeight: "400 !important"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const typographySx = t5;
  const t6 = noWrap ? 0 : undefined;
  const t7 = noWrap ? "100%" : undefined;
  const t8 = disabled ? "var(--mui-palette-background-disabled)" : "transparent";
  const t9 = disabled ? "transparent" : statusColor ?? (variant === "primary" ? "var(--mui-palette-primary-main)" : "var(--mui-palette-divider)");
  let t10;
  if ($[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9 || $[13] !== typographySx) {
    t10 = {
      alignItems: "center",
      gap: "4px",
      width: "fit-content",
      minWidth: t6,
      maxWidth: t7,
      ...typographySx,
      backgroundColor: t8,
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: t9
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = typographySx;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== icon) {
    t11 = icon && <i className={icon} />;
    $[15] = icon;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = noWrap ? undefined : "break-all";
  const t13 = noWrap ? 0 : undefined;
  let t14;
  if ($[17] !== t12 || $[18] !== t13 || $[19] !== typographySx) {
    t14 = {
      wordBreak: t12,
      minWidth: t13,
      ...typographySx
    };
    $[17] = t12;
    $[18] = t13;
    $[19] = typographySx;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = variant === "secondary" ? "body2" : "subtitle2";
  let t16;
  if ($[21] !== content || $[22] !== noWrap || $[23] !== t14 || $[24] !== t15) {
    t16 = <Typography noWrap={noWrap} sx={t14} variant={t15}>{content}</Typography>;
    $[21] = content;
    $[22] = noWrap;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== ref || $[27] !== rest || $[28] !== t10 || $[29] !== t11 || $[30] !== t16) {
    t17 = <Stack direction="row" {...rest} ref={ref} className="px-[8px] py-[3px] rounded-[4px] flex-inline vertical-align-middle" sx={t10}>{t11}{t16}</Stack>;
    $[26] = ref;
    $[27] = rest;
    $[28] = t10;
    $[29] = t11;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
});